import { RouteObject } from 'react-router-dom'
import GeneralSettings from '../pages/application-preferences/GeneralSettings.page'
import { AgentScheduleSettings } from '../pages/application-preferences/AgentScheduleSettings.page'

export const applicationPreferencesRoutes: RouteObject = {
  path: 'application-preferences',
  children: [
    {
      path: 'general-settings',
      element: <GeneralSettings />,
      handle: {
        crumb: () => 'Application Preferences / General Settings',
      },
    },
    {
      path: 'agent-schedule-settings',
      element: <AgentScheduleSettings />,
      handle: {
        crumb: () => 'Application Preferences / Agent Schedule Settings',
      },
    },
  ],
}
